module.exports = __webpack_public_path__ + "static/media/as.e0408341.svg";